module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contenedor-lista"
  }, [_vm._m(0), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "information"
  }, [(_vm.lista.length !== 0) ? _vm._l((_vm.lista), function(o, index) {
    return _c('div', {
      key: index,
      staticClass: "clase-item"
    }, [(o && o.idYT) ? _c('img', {
      staticClass: "clase-imagen",
      attrs: {
        "src": 'https://img.youtube.com/vi/' + o.idYT + '/hqdefault.jpg',
        "alt": o.titulo
      }
    }) : _vm._e(), _c('div', {
      staticClass: "clase-detalles"
    }, [_c('div', {
      staticClass: "clase-header"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("truncateText")(o.titulo, 20)))]), (o.descripcion) ? _c('div', {
      staticClass: "descripcion"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("truncateText")(o.descripcion, 30)))])]) : _vm._e()]), _c('div', {
      staticClass: "clase-info"
    }, [_c('span', [_vm._v("Duración: " + _vm._s(o.duracion))])])]), _c('div', {
      staticClass: "clase-botones"
    }, [(o.estado === 0) ? _c('button', {
      staticClass: "button is-primary",
      on: {
        "click": function($event) {
          return _vm.verClase(o.id, o.estado)
        }
      }
    }, [_vm._v("Ver clase")]) : _c('button', {
      staticClass: "button",
      on: {
        "click": function($event) {
          return _vm.verClase(o.id, o.estado)
        }
      }
    }, [_vm._v("Volver a ver")])])])
  }) : _vm._e()], 2), (!_vm.isLoading && _vm.lista.length === 0) ? _c('div', [_vm._m(1)]) : _vm._e(), (_vm.isLoading) ? _c('div', {
    staticClass: "is-loading"
  }, [_vm._m(2)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Mis clases")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("No hay clases registrados")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14c301e1","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_cursos_virtuales_clase_lista.vue
// module id = 830
// module chunks = 0